module.exports = __webpack_public_path__ + "img/selected2-min.1cd1aa2a.png";